import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { Rating } from "primereact/rating";
import { Toolbar } from "primereact/toolbar";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import styled from "styled-components";

export const MainDiv = styled.div``;
export const MainCard = styled.div`
  /* padding-top: 5rem; */
`;
export const Toolbars = styled(Toolbar)``;
export const DataTables = styled(DataTable)``;
export const Columns = styled(Column)``;
export const Dialogs = styled(Dialog)``;
export const Field = styled.div``;
export const Label = styled.label``;
export const InputTexts = styled(InputText)``;
export const InputTextareas = styled(InputTextarea)``;
export const FormGrid = styled.div``;
export const Fieldradiobutton = styled.div``;
export const RadioButtons = styled(RadioButton)``;
export const InputNumbers = styled(InputNumber)``;
export const ConfirmationContent = styled.div``;
export const PiLi = styled.li``;

export const NftListingVideo = styled.video`
  width: 100%;
  height: 15vh !important;
`;
